import angular from 'angular';

export default angular.module('shared').constant('cookieConstants', {
    appspaceDomain: '.appspace.com',
    cloudToken: 'appspace-cloud-token'
});



// WEBPACK FOOTER //
// ./modules/shared/constants/cookie.constant.js